module.exports = __webpack_public_path__ + "static/media/tab-img-3.ab324b61.jpg";